"use strict";

import {
  addFormControlSelect2,
  appendXSelectedCompanyHeader,
  checkIfValidSelect,
  createDropzoneMockfiles,
  dropdownFix,
  dropzoneExists,
  fnErrorMsg,
  fnToastrFormError,
  getSelectedCompanyForUser,
  popupCenterDual,
  printResponse,
  reloadVouchersTableWithMissingVoucherText,
  resetForm,
  setMissingVoucherText,
  setSelect,
  toggleLoader,
  validateVoucherLimit,
} from "../jquery-functions-library";
import { addExportBtns } from "./voucher-table-export";
import * as Dropzone from "dropzone"; //TODO
import { element_exists, redesignDataTablesHeader } from "../functions";

/**
 * Created by simonadams on 15/12/2016.
 */
export var fnUploadVoucher = function () {
  var tableName = "#datatable-vouchers";

  $(document)
    .off("click", ".dropdownVouchersButtons")
    .on("click", ".dropdownVouchersButtons", function () {
      dropdownFix(this);
    });
  $(document)
    .off("click", ".dropdownVoucherItems .dropdown-item")
    .on("click", ".dropdownVoucherItems .dropdown-item", function () {
      let filePath = $(this).data("filepath");
      let href = $(this).data("href");
      popupCenterDual(
        href,
        filePath,
        window.innerWidth / 3,
        window.innerHeight / 1.5
      );
    });
  $(document)
    .off("click.hideTableDropdown")
    .on({
      "click.hideTableDropdown": function () {
        $(".dropdown-menu[data-parent]").hide();
      },
    });

  if (
    !element_exists(tableName) ||
    $.fn.dataTable.isDataTable(tableName) ||
    !element_exists("#myDropzone") /* || !element_exists('#selected_company')*/
  ) {
    return false;
  }

  var selectedCompany = getSelectedCompanyForUser();
  var updateUrl = "/voucher/get/all/" + selectedCompany;
  var form = $("#form-upload-voucher");
  var uploadUrl = "/voucher/store";
  var modalUpload = $("#modal-upload-voucher");
  var rowData;
  var modalBtnSave = modalUpload.find("#modal-btn-save");
  var modalBtnSaveAndClose = modalUpload.find("#modal-btn-save-and-close");

  $.ajaxSetup({ headers: { "X-CSRF-TOKEN": $('[name="_token"]').val() } });

  if (!dropzoneExists("#myDropzone")) {
    Dropzone.autoDiscover = false;

    var langDropzone = allLangFiles.dropzone;

    let MAX_FILES_ALLOWED = 4;
    const MAX_FILE_SIZE = 8;

    $("#myDropzone").dropzone({
      dictDefaultMessage: langDropzone.dictCustomDropMessage,
      dictFallbackMessage: langDropzone.dictFallbackMessage,
      dictFallbackText: langDropzone.dictFallbackText,
      dictFileTooBig: langDropzone.dictFileTooBig,
      dictInvalidFileType: langDropzone.dictInvalidFileType,
      dictResponseError: langDropzone.dictResponseError,
      dictCancelUpload: langDropzone.dictCancelUpload,
      dictCancelUploadConfirmation: langDropzone.dictCancelUploadConfirmation,
      dictRemoveFile: langDropzone.dictRemoveFile,
      dictMaxFilesExceeded: langDropzone.dictMaxFilesExceeded,

      url: uploadUrl,
      addRemoveLinks: true,
      autoDiscover: false,
      uploadMultiple: true,
      parallelUploads: MAX_FILES_ALLOWED,
      maxFiles: MAX_FILES_ALLOWED,
      maxFilesize: MAX_FILE_SIZE,
      acceptedFiles: "image/*,application/pdf",
      autoProcessQueue: false, // this is important as you dont want form to be submitted unless you have clicked the submit button

      sendingmultiple: function (file, xhr, formData) {
        // Passing formvalues associated to dropzone
        $.each(form.serializeArray(), function (k, v) {
          formData.append(v.name, v.value);
        });
        //Attach department_name to form
        formData.append(
          "department_name",
          getSelectedOptionText($("#DepartmentHandle_Number"))
        );
        appendXSelectedCompanyHeader(xhr);
      },

      init: function () {
        /*Only use this on methods. Can cause errors if using this inside a method (e.g. button-clicks...)*/
        var myDropzone = this;

        myDropzone.uploadCompleted = false;

        myDropzone.cleaningUp = false;

        myDropzone.closeWhenDone = false;

        this.resetState = function () {
          myDropzone.cleaningUp = false;
          myDropzone.removeAllFiles();
          myDropzone.cleaningUp = false;
          myDropzone.uploadCompleted = false;
          myDropzone.closeWhenDone = false;
        };

        /*Custom methods */
        this.cleanUp = function () {
          resetForm($("#form-upload-voucher"));

          myDropzone.cleaningUp = true;
          myDropzone.removeAllFiles();
          myDropzone.cleaningUp = false;
          myDropzone.uploadCompleted = false;
          myDropzone.closeWhenDone = false;
        };

        function mockFileErrorHandler() {
          return function errorHandler(response) {
            console.log(response);

            myDropzone.setupEventListeners();

            $("#btn-display-voucher").fadeOut();
          };
        }

        function unauthorizedErrorHandler() {
          modalUpload.modal("hide");
        }

        this.modalBehaviour = function (rowData) {
          let mockfiles = $(".dz-preview.dz-complete.dz-image-preview");
          mockfiles.remove();

          if (rowData.files_without_data.length > 0) {
            createDropzoneMockfiles(
              "/voucher/files/info/" + rowData.id,
              myDropzone,
              mockFileErrorHandler,
              unauthorizedErrorHandler
            );
          }
          if (rowData.files_without_data.length >= MAX_FILES_ALLOWED) {
            myDropzone.removeEventListeners();
          }
        };

        function updateWithoutStoringAttachment(form, departmentSelect, url) {
          var serializedFormData = form.serialize();
          var serializedFormData = serializedFormData.replace(
            "no_voucher=",
            "no_voucher=1"
          );
          var selectedDepartmentName = departmentSelect
            .find("option:selected")
            .text()
            .trim();

          // Regex from chatGPT to capture everything after the "-" character in the department name
          var departmentNameMatch = selectedDepartmentName.match(/-\s*(.*)/);

          var departmentName = departmentNameMatch
            ? departmentNameMatch[1].trim()
            : selectedDepartmentName;

          var formData =
            serializedFormData + "&department_name=" + departmentName;

          $.ajax({
            method: "POST",
            url: url,
            data: formData,
            success: function (response) {
              console.log(response);
              printResponse(response);

              if (myDropzone.closeWhenDone) {
                modalUpload.modal("hide");
              }
            },
            error: fnToastrFormError,
          });
        }

        this.onclickSaveForm = function (form, url, noVoucher, closeWhenDone) {
          var accountSelect = $("#AccountHandle_Number");
          var departmentSelect = $("#DepartmentHandle_Number");
          var accountIsValid = checkIfValidSelect(accountSelect);

          myDropzone.closeWhenDone = closeWhenDone;

          if (!accountIsValid) {
            return false;
          }

          // console.log(!noVoucher);
          // console.log(!noVoucher && !myDropzone.uploadCompleted);
          // console.log(!myDropzone.uploadCompleted);
          if (!noVoucher) {
            console.log(myDropzone.uploadCompleted);
            if (!myDropzone.uploadCompleted) {
              //TODO fix error when uploading and deleting at same time - can't close window...
              myDropzone.processQueue();
            } else {
              updateWithoutStoringAttachment(form, departmentSelect, url);
            }
          } else {
            if (noVoucher && $("#upload_comment").val() == "") {
              $("#upload_comment").focus();
              return false;
            }
            updateWithoutStoringAttachment(form, departmentSelect, url);
          }
        };
        /*End custom methods*/

        /*Standard methods*/
        this.on("queuecomplete", function (file) {
          if (myDropzone.files[0].status !== Dropzone.ERROR) {
            // solve for dropzone.js bug : https://github.com/enyo/dropzone/issues/578
            // if the first file is invalid then do nothing
            // this event has been fired prematurely
            console.log("queuecomplete");
            myDropzone.uploadCompleted = true;

            if (myDropzone.closeWhenDone) {
              modalUpload.modal("hide");
            }
          }
        });

        this.on("thumbnail", function (file) {
          console.log("thumbnail");
          let filename = file.name;
          let url = file.url;

          // console.log(file.previewElement);
          $(file.previewElement)
            .off("click")
            .on("click", function (e) {
              popupCenterDual(
                url,
                filename,
                window.innerWidth / 3,
                window.innerHeight / 1.5
              );
            });
        });

        this.on("maxfilesreached", function () {
          console.log("maxfilesreached");

          myDropzone.removeEventListeners();
        });

        this.on("addedfile", function () {
          console.log("addedfile");
          if (myDropzone.files.length >= MAX_FILES_ALLOWED) {
            myDropzone.removeEventListeners();
          }
          myDropzone.uploadCompleted = false;
        });

        this.on("success", function (file, response) {
          console.log("success");
          console.log(response.data);
          console.log(file);
          for (let i = 0; i < response.data.files.length; i++) {
            let storedFile = response.data.files[i];
            if (file.name == storedFile.original_filename) {
              $(file.previewElement)
                .off("click")
                .on("click", function (e) {
                  popupCenterDual(
                    storedFile.url,
                    storedFile.path,
                    window.innerWidth / 3,
                    window.innerHeight / 1.5
                  );
                });
              break;
            }
          }

          $(".dz-complete").addClass(".dz-success");

          $("#btn-display-voucher").fadeIn(); //TODO find this and fix
          console.log(MAX_FILES_ALLOWED);

          if (myDropzone.files.length >= MAX_FILES_ALLOWED) {
            modalBtnSave.fadeOut();
          }
        });

        this.on("removedfile", function (file) {
          modalBtnSave.fadeIn();

          if (myDropzone.files.length < MAX_FILES_ALLOWED) {
            myDropzone.setupEventListeners();
          }

          if (!myDropzone.cleaningUp) {
            /* Delete file from server */
            /*Only run delete if file was uploaded*/
            if (file.status === "success" || file.status === "mockFile") {
              const data = {
                filename: file.name,
                file_id: file.file_id,
                /*DB table id*/
                id: form.find("#id").val(),
              };
              console.log(data);
              $.ajax({
                type: "POST",
                url: "/voucher/delete",
                data: data,
                /*dataType: 'html',*/
                success: function (data) {
                  myDropzone.uploadCompleted = myDropzone.files.length !== 0;
                  if (!myDropzone.uploadCompleted) {
                    $("#btn-display-voucher").fadeOut();
                  }
                },
                error: function (error) {
                  fnToastrFormError(error);
                  modalUpload.modal("hide");
                },
              });
            }
          }
        });
        /*End standard methods*/
      },
    });
  }

  /*TODO Column names for datatable, set on server side */
  var columns = [
    { data: "company_id" },
    { data: "select" },
    {
      data: "Date",
      render: function (data, type, row) {
        var d = new Date(row.Date);
        return d.toLocaleDateString(undefined, {
          month: "2-digit",
          day: "2-digit",
          year: "2-digit",
        });
      },
    },
    { data: "VoucherNumber" },
    { data: "Text" },
    {
      data: "Amount",
      render: function (data, type, row) {
        return Intl.NumberFormat("da-DK").format(row.Amount);
      },
    },
    { data: "Account" },
    { data: "ContraAccount" },
    {
      data: "department_name",
      render: function (data, type, row) {
        if (row.department_name) {
          return row.DepartmentHandle_Number + " - " + row.department_name;
        } else {
          return "";
        }
      },
    },
    { data: "comment" },
    { data: "PdfUploaded" },
  ];

  /*Rules for filling the columns*/
  var columnDefs = [
    { visible: false, targets: 0 },
    {
      orderable: false,
      checkboxes: {
        selectRow: true,
      },
      className: "select-checkbox-gyro dt-center not-export",
      targets: 1,
    },
    { width: "5%", targets: 2 },
    { className: "dt-right", width: "3%", targets: 3 },
    { width: "20%", targets: 4 },
    { className: "dt-right", width: "5%", targets: 5 },
    { width: "10%", targets: 6 },
    { width: "5%", targets: 7 },
    { width: "10%", targets: 8 },
    { width: "25%", targets: 9 },
    { width: "12%", className: "not-export", targets: 10 },
  ];

  /*Important otherwise table misaligned*/
  $(tableName).css("width", "100%");

  var table = $(tableName).DataTable({
    destroy: true,
    language: allLangFiles.datatables,
    rowId: "id",
    ajax: {
      url: updateUrl,
      dataSrc: function (json) {
        console.log("dataSrc");

        return json.data;
      },
    },
    select: {
      style: "multi",
      selector: "td:first-child",
      info: false,
    },
    /*serverSide: true,
         processing: false,
         deferRender: true,*/
    columns: columns,
    columnDefs: columnDefs,
    iDisplayLength: 100,
    scrollX: true,
    lengthMenu: [
      [10, 25, 50, 75, 100, -1],
      [10, 25, 50, 75, 100, allLangFiles.datatables.all],
    ],
    initComplete: function (settings, json) {
      console.log("initComplete");

      setMissingVoucherText();

      table.draw();
    },
  });

  const { $filterButtons } = redesignDataTablesHeader(
    tableName,
    true,
    null,
    false
  );
  //duplicates the buttons, so important that all but last button groups are hidden
  $(document)
    .off("click", ".tab-vouchers-current")
    .on("click", ".tab-vouchers-current", function () {
      addExportBtns($(tableName), 4);
    });
  $filterButtons.prepend($("#voucherBulkButton"));

  var langVouchers = allLangFiles.vouchers.js;

  $(tableName + " tbody")
    .off("click", ".btn-approve")
    .on("click", ".btn-approve", function () {
      var btnElement = this;
      var data = table.row($(this).parents("tr")).data();

      confirmSingleUploadToastr(data, table, langVouchers, btnElement);
    });

  $(tableName + " tbody")
    .off("click", ".btn-register,.btn-edit")
    .on("click", ".btn-register,.btn-edit", function () {
      var tableRow = table.row($(this).parents("tr"));
      rowData = tableRow.data();

      createUploadForm(rowData, form, modalUpload, langVouchers);
      loadAccounts(rowData, form, langVouchers);
      loadDepartments(rowData, form, langVouchers);

      var showFile = rowData.files_without_data.length > 0;

      /*Creates mockfile if file exists in storage*/
      if (showFile) {
        $("#myDropzone")[0].dropzone.modalBehaviour(rowData);
        $("#btn-display-voucher").show();
      } else {
        $("#btn-display-voucher").hide();
      }

      $("#modal-upload-voucher")
        .off("hidden.bs.modal")
        .on("hidden.bs.modal", function () {
          /*Clean up*/
          $("#myDropzone")[0].dropzone.cleanUp();
          table.ajax.reload(null, false);
        });

      modalUpload.modal("show");
    });

  $("#no_voucher")
    .off("change")
    .on("change", function (e) {
      /*$('#myDropzone')[0].dropzone.onVoucherSelected();*/

      if ($("#no_voucher").is(":checked")) {
        if ($("#myDropzone")[0].dropzone.files.length) {
          $("#myDropzone")[0].dropzone.resetState();
        }

        $("#myDropzone").hide();
        $("#alert-no-voucher").fadeIn();
      } else {
        $("#myDropzone").show();
        $("#alert-no-voucher").hide();
      }
    });

  modalBtnSave.off("click").on("click", function (e) {
    var closeWhenDone = false;

    $("#myDropzone")[0].dropzone.onclickSaveForm(
      form,
      uploadUrl,
      $("#no_voucher").is(":checked"),
      closeWhenDone
    );
  });

  modalBtnSaveAndClose.off("click").on("click", function (e) {
    var closeWhenDone = true;

    $("#myDropzone")[0].dropzone.onclickSaveForm(
      form,
      uploadUrl,
      $("#no_voucher").is(":checked"),
      closeWhenDone
    );
  });

  $(document).off("click", ".btn-display-voucher");
  $(document).on("click", ".btn-display-voucher", function (e) {
    e.preventDefault();

    var data = table.row($(this).parents("tr")).data();
    popupCenterDual(
      "voucher/file/" + data.id,
      data.Text,
      window.innerWidth / 3,
      window.innerHeight / 1.5
    );
  });

  form
    .find(":input")
    .off("input")
    .on("input", function () {
      if (modalBtnSave.is(":hidden")) {
        modalBtnSave.show();
      }
    });

  $("#nav-tab-vouchers .nav-link")
    .off("click")
    .on("click", function (e) {
      if ($(this).hasClass("tab-vouchers-current")) {
        $("#vouchers-progress").show();
      } else {
        $("#vouchers-progress").hide();
      }

      if ($(this).hasClass("active")) return;
      var tabId = $(this).attr("data-target");
      var tableName = $(tabId).attr("data-table-name");
      setTimeout(function () {
        $(tableName).DataTable().draw();
      }, 200);
    });

  $(document)
    .off("click", ".your-button-class")
    .on("click", ".your-button-class", function () {
      let voucherId = $(this).data("voucher-id");
    });

  $(tableName + " tbody")
    .off("click", ".btn-danger[data-voucher-id]")
    .on("click", ".btn-danger[data-voucher-id]", function () {
      const voucherId = $(this).data("voucher-id");

      $.confirm({
        title: allLangFiles.vouchers.select.title,
        content: allLangFiles.vouchers.select.delete_voucher_confirm,
        theme: "supervan",
        columnClass: "col-md-12",
        backgroundDismiss: true,
        buttons: {
          Ja: {
            action: function () {
              $.ajax({
                type: "POST",
                url: "/voucher/attachment/delete",
                data: { voucher_id: voucherId },
                success: function (response) {
                  if (response.success) {
                    reloadVouchersTableWithMissingVoucherText();
                    toastr.success(response.success);
                  } else {
                    toastr.error(response.error);
                  }
                },
                error: function (error) {
                  console.error("Error:", error);
                  toastr.error(
                    "An error occurred while deleting the voucher attachment"
                  );
                },
              });
            },
            text: allLangFiles.vouchers.select.yes,
          },
          Nej: {
            text: allLangFiles.vouchers.select.no,
          },
        },
      });
    });
};

function createUploadForm(data, form, modal) {
  resetForm(form);
  modal.find(".modal-title").html("");

  var editableFieldsKey = ["comment"];
  var hiddenFieldsKey = ["id"];

  $.each(hiddenFieldsKey, function (k, v) {
    form.find("#" + v).val(data[v]);
  });

  $.each(editableFieldsKey, function (k, v) {
    form.find("#" + v).val(data[v]);
  });
  form.find("#upload_comment").val(data.comment);
  form.find("#no_voucher").prop("checked", data.no_voucher);

  modal.find(".modal-title").html("Upload bilag til: " + data.Text);

  if ($("#no_voucher").is(":checked")) {
    $("#myDropzone").hide();
    $("#alert-no-voucher").fadeIn();
  } else {
    $("#myDropzone").show();
    $("#alert-no-voucher").hide();
  }
}

function confirmSingleUploadToastr(data, table, lang, btnElement) {
  var isOverLimit = false;
  var currentSum = 0;

  if (data.no_voucher === 1) {
    currentSum = Math.abs(data.Amount);
  }

  var validation = validateVoucherLimit(lang, currentSum, function (overLimit) {
    isOverLimit = overLimit;
  });

  $.confirm({
    title: lang.approve_title + data.Text,
    content: lang.approve_content + validation,
    theme: "supervan",
    columnClass: "col-md-12",
    backgroundDismiss: true,
    buttons: {
      Ja: {
        action: function () {
          if (isOverLimit) {
            var isChecked = $("#accept-agreement").is(":checked");
            if (!isChecked) {
              $.alert(lang.approve_alert);
              return false;
            }
          }

          toggleLoader(btnElement, true);

          $.ajax({
            type: "POST",
            url: "/voucher/upload/specific",
            data: data,
            success: function (response) {
              if (response.success !== undefined) {
                toastr.success(response.success);
                reloadVouchersTableWithMissingVoucherText();
              } else {
                toggleLoader(btnElement, false);

                toastr.error(response.error);
              }
            },
            error: function (error) {
              fnToastrFormError(error);
              reloadVouchersTableWithMissingVoucherText();
            },
          });
        },
        text: lang.yes,
      },
      Nej: {
        text: lang.no,
      },
    },
  });
}

function loadAccounts(rowData, form, lang) {
  $.ajax({
    method: "GET",
    url: "/voucher/approved-accounts/" + rowData.company_id,
    success: function (response) {
      var accounts = response.collectionEconomicAccounts;

      setSelect(
        accounts,
        $("#AccountHandle_Number"),
        "accountNumber",
        ["accountNumber", "name"],
        lang.account_select
      );

      if (rowData.AccountHandle_Number !== 0) {
        form
          .find(
            '#AccountHandle_Number option[value="' +
              rowData.AccountHandle_Number +
              '"]'
          )
          .prop("selected", true);
      } else {
        $("#AccountHandle_Number option").prop("selected", false);
      }
      $("#AccountHandle_Number")
        .select2({
          placeholder: lang.account_select,
          width: "271px",
          height: "75%",
          dropdownParent: $("#modal-upload-voucher"),
        })
        .addClass("form-control");
      addFormControlSelect2();
    },
    error: fnErrorMsg,
  });
}

function loadDepartments(rowData, form, lang) {
  $.ajax({
    method: "GET",
    url: "/voucher/departments/" + rowData.company_id,
    success: function (response) {
      var departments = response.departments;

      if (departments.length > 0) {
        // custom setSelect function to format department names with department numbers
        setSelectWithCustomFormatting(
          departments,
          $("#DepartmentHandle_Number"),
          "departmentNumber",
          lang.department_select,
          customFormatDepartmentName
        );
        $("#DepartmentHandle_Number")
          .parents(".form-group.bmd-form-group")
          .removeClass("hidden");

        if (rowData.DepartmentHandle_Number !== 0) {
          form
            .find(
              '#DepartmentHandle_Number option[value="' +
                rowData.DepartmentHandle_Number +
                '"]'
            )
            .prop("selected", true);
        } else {
          $("#DepartmentHandle_Number option").prop("selected", false);
        }
        $("#DepartmentHandle_Number")
          .select2({
            width: "271px",
            height: "75%",
            dropdownParent: $("#modal-upload-voucher"),
          })
          .addClass("form-control");
        addFormControlSelect2();
      } else {
        $("#DepartmentHandle_Number")
          .parents(".form-group.bmd-form-group")
          .addClass("hidden");
      }
    },
    error: fnErrorMsg,
  });
}

// Custom formatting function to format department name with department number
function customFormatDepartmentName(department) {
  return department.departmentNumber + " - " + department.name;
}

// Wrapper function to format department names and call setSelect
function setSelectWithCustomFormatting(
  dataArray,
  element,
  value,
  defaultOption,
  formatTextCallback
) {
  // Modify the dataArray to include the custom formatted text
  var formattedDataArray = dataArray.map(function (department) {
    return {
      ...department,
      name: formatTextCallback(department),
    };
  });

  // Call the original setSelect function with the modified dataArray
  setSelect(formattedDataArray, element, value, "name", defaultOption);
}

function getSelectedOptionText(select) {
  return select.find("option:selected").val() !== "default"
    ? select.find("option:selected").text()
    : "";
}
